import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { AdvancedNotificationsEmailFailActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function AdvancedNotificationsEmailFail({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as AdvancedNotificationsEmailFailActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》邮件提醒发送失败</ItemWrapper>
}
